import React, { useState, useContext } from "react";
import { Button } from "./Button";
import { Link } from "react-router-dom";
//import ConfirmLogout from './../common/confirmLogout';
import "./Navbar.css";
import Dropdown from "./Dropdown";
import DropdownReport from "./Dropdown2";
import Dropdown2 from "./DropdownApprove";
import auth from "../../services/authService";
import Clock from "react-live-clock";
import PrivilegeContext from "../context/privilege";
import LeftMenu from "./LeftMenu";

function Navbar(props) {
  const { user } = props;
  const privilegeContext = useContext(PrivilegeContext);
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [showreport, setshowreport] = useState(false);
  const [showemegency, setshowemegency] = useState(false);
  const [showapproved, setshowapproved] = useState(false);
  // const [collapsed ,setcollapsed] = useState(true) ;
  //const [isModalLogoutOpen ,setisModalLogoutOpen] = useState(false) ;
  // const hide = () => setcollapsed(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const onMouseEnter = () => {
    if (window.innerWidth < 200) {
      setDropdown(false);
    } else {
      setDropdown(true);
    }
  };
  const onMouseReportEnter = () => {
    if (window.innerWidth < 200) {
      setshowreport(false);
    } else {
      setshowreport(true);
    }
  };

  const onMouseEmerEnter = () => {
    if (window.innerWidth < 200) {
      setshowemegency(false);
    } else {
      setshowemegency(true);
    }
  };

  const onMouseApprovedEnter = () => {
    if (window.innerWidth < 200) {
      setshowapproved(false);
    } else {
      setshowapproved(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth < 200) {
      setDropdown(false);
    } else {
      setDropdown(false);
    }
  };

  const onMouseApprovedLeave = () => {
    if (window.innerWidth < 200) {
      setshowapproved(false);
    } else {
      setshowapproved(false);
    }
  };
  const onMouseReportLeave = () => {
    if (window.innerWidth < 200) {
      setshowreport(false);
    } else {
      setshowreport(false);
    }
  };
  const onMouseEmerLeave = () => {
    if (window.innerWidth < 200) {
      setshowemegency(false);
    } else {
      setshowemegency(false);
    }
  };

  const hide = (event) => {
    // console.log('you click',event)
    auth.logout();
    window.location = "/";
  };

  const onOpenReportItem = () => {
    setshowreport(!showreport);
  };
  const onCloseMenu = () => {
    setshowreport(!showreport);
  };
  const onOpenItem = () => {
    setDropdown(!dropdown);
  };
  const onOpenEmerItem = () => {
    setshowemegency(!showemegency);
  };

  const onOpenApprovedItem = () => {
    setshowapproved(!showapproved);
  };
  //   const onLogoutConfirm = () => {
  //     setisModalLogoutOpen(false);
  // }

  // const onLogoutCancel =() => {
  //   setisModalLogoutOpen(false);
  // }
  //console.log(dropdown)
  // console.log('Navbar =',user);
  return (
    <>
      <nav className="navbar-custom justify-content-between  ">
        <Link to="/" className="navbar-logo-custom" onClick={closeMobileMenu}>
          Fire extinguishers
          <i className="fa fa-fire-extinguisher ml-2" />
          {user && (
            <div className="d-none d-md-inline text-white text-muted">
              <img
                src={
                  "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=" +
                  user.empid +
                  "&size=320"
                }
                className="rounded-circle mr-2 ml-4"
                data-toggle="tooltip"
                data-placement="bottom"
                title=""
                alt=""
                style={{
                  maxHeight: "50px",
                  Width: "100%",
                  maxWidth: "30px",
                }}
              ></img>
            </div>
          )}
          <strong
            className="d-none d-xl-inline ml-2 "
            style={{ fontSize: "14px" }}
          >
            <Clock format="ddd" ticking={true} interval={60000} />
          </strong>
          <strong
            className="d-none d-md-inline ml-2 "
            style={{ fontSize: "14px" }}
          >
            <Clock format="D MMM YYYY" ticking={true} interval={60000} />
          </strong>
          <strong
            className="d-none d-xl-inline ml-2 "
            style={{ fontSize: "14px" }}
          >
            <Clock format="HH:mm:ss" ticking={true} interval={1000} />
          </strong>
        </Link>

        {/* {user && <div className="navbar-time" >
            <strong className="d-none d-xl-inline ml-2"><Clock format="ddd" ticking={true} interval={60000} /></strong>
            <strong className="d-none d-md-inline ml-2">
              <Clock format="D MMMM YYYY" ticking={true} interval={60000} />
            </strong>
            <strong className="d-none d-md-inline ml-2"><Clock format="HH:mm:ss" ticking={true} interval={1000} /></strong>
          </div>} */}
        <div className="menu-icon-custom" onClick={handleClick}>
          <i className={click ? "fas fa-times" : "fas fa-bars"} />
        </div>

        {/* <div className="col-3"></div> */}
        <div
          className={
            click ? "nav-menu-custom active" : "nav-menu-custom"
          }
        >
          <LeftMenu />
          {/* {   user && <li
            className="nav-item-custom"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            
            <Link
             to =""
               className="nav-links-custom"
               onClick={onOpenItem}
               
            >
              การจัดการ <i className="fas fa-caret-down" />
            </Link>
            { user && dropdown && 
           
           <Dropdown
            onClick = {closeMobileMenu}
            >
              
            </Dropdown>
           }
          </li>}

          { user && <li
            className="nav-item-custom"
            onMouseEnter={onMouseApprovedEnter}
            onMouseLeave={onMouseApprovedLeave}
          >
            <Link
              to =""
              className="nav-links-custom"
              
               onClick={onOpenApprovedItem}
            >
              การทำงาน
              <i className="fas fa-caret-down" />
            </Link>
            {showapproved && <Dropdown2
             onClick = {closeMobileMenu} 
             />}
         
          </li>}
      

          { user && <li
            className="nav-item-custom"
            onMouseEnter={onMouseReportEnter}
            onMouseLeave={onMouseReportLeave}
          >
            <Link
              to =""
              className="nav-links-custom"
              onClick={onOpenReportItem}
            >
              รายงาน
              <i className="fas fa-caret-down" />
            </Link>
            {showreport && <DropdownReport
             onClick = {closeMobileMenu} 
             />}
          </li>} */}

          {/* { user && <li className="nav-item">
            <Link
              to="/registernotebook"
              className="nav-links"
              onClick={closeMobileMenu}
            >
              Notebook
            </Link>
          </li>} */}

          {/* { user && <li className="nav-item">
            <Link
              className="btn btn-outline-success my-2 my-sm-0"
              to="/registeroffice"
              className="nav-links"
              onClick={closeMobileMenu}
            >
              Office
            </Link>
          </li>} */}
          {user ? (
            <li>
              <Link to="logout" className="nav-links-mobile" onClick={hide}>
                Sign Out
              </Link>
            </li>
          ) : (
            <li>
              <Link to="login" className="nav-links-mobile">
                Sign In
              </Link>
            </li>
          )}

          {/* <li className="nav-item">
            <Link to="logout">
              <div>
                <button className="btn-custom mb-4">Sign Out</button>
              </div>
            </Link>
          </li> */}
        </div>

        <Button user={user} onClick={hide}></Button>
      </nav>
    </>
  );
}

export default Navbar;
